/**
 * @module 各種完確認表示用コンポーネント
 */
import ThanksPageTitle from './ThanksPageTitle.vue';

export default {
  name: 'ThanksSimpleConfirmation',
  components: {
    ThanksPageTitle,
  },
  data(vm) {
    return {
      pageInfo: this.fromPageInfo,
      contents: 0,
      contentsInfo: [
        // ToDo変数名変更
        {
          id: 0,
          page: 51,
          title: vm.$vuetify.lang.t(
            '$vuetify.FECU54Thanks画面.メッセージ表示領域.アカウント削除完了'
          ), //"アカウント削除完了", // FE-CU54-C0011
          text: vm.$vuetify.lang.t(
            '$vuetify.FECU54Thanks画面.メッセージ詳細表示領域.アカウントを削除しました'
          ), //"アカウントを削除しました。\nご利用ありがとうございました。", // FE-CU54-C0015
        },
        {
          id: 1,
          page: 531,
          title: vm.$vuetify.lang.t(
            '$vuetify.FECU54Thanks画面.メッセージ表示領域.サブユーザー本登録完了'
          ), //"サブユーザー本登録完了", // FE-CU54-C0012
          text: vm.$vuetify.lang.t(
            '$vuetify.FECU54Thanks画面.メッセージ詳細表示領域.サブユーザーを本登録しました'
          ), //"サブユーザーを本登録しました。", // FE-CU54-C0016
        },
        {
          id: 2,
          page: 532,
          title: vm.$vuetify.lang.t(
            '$vuetify.FECU54Thanks画面.メッセージ表示領域.メインユーザー本登録完了'
          ), //"メインユーザー本登録完了", // FE-CU54-C0013
          text: vm.$vuetify.lang.t(
            '$vuetify.FECU54Thanks画面.メッセージ詳細表示領域.メインユーザーを本登録しました'
          ), //"メインユーザーを本登録しました。", // FE-CU54-C0017
        },
        {
          id: 3,
          page: 6,
          title: vm.$vuetify.lang.t(
            '$vuetify.FECU54Thanks画面.メッセージ表示領域.パスワード初期化完了'
          ), //"パスワード初期化完了", // FE-CU54-C0014
          text: vm.$vuetify.lang.t(
            '$vuetify.FECU54Thanks画面.メッセージ詳細表示領域.パスワードを初期化しました'
          ), //"パスワードを初期化しました。", // FE-CU54-C0018
        },
        {
          title: vm.$vuetify.lang.t(
            '$vuetify.FECU54Thanks画面.メッセージ表示領域.サービス追加完了'
          ), //"サービス追加完了", // FE-CU54-C0023
          text: vm.$vuetify.lang.t(
            '$vuetify.FECU54Thanks画面.メッセージ詳細表示領域.サービスを追加しました'
          ), //"サービスを追加しました。", // FE-CU54-C0024?
        },
      ],
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        contentsInfo: [
          // ToDo変数名変更
          {
            id: 0,
            page: 51,
            title: vm.$vuetify.lang.t(
              '$vuetify.FECU54Thanks画面.メッセージ表示領域.アカウント削除完了'
            ), //"アカウント削除完了", // FE-CU54-C0011
            text: vm.$vuetify.lang.t(
              '$vuetify.FECU54Thanks画面.メッセージ詳細表示領域.アカウントを削除しました'
            ), //"アカウントを削除しました。\nご利用ありがとうございました。", // FE-CU54-C0015
          },
          {
            id: 1,
            page: 531,
            title: vm.$vuetify.lang.t(
              '$vuetify.FECU54Thanks画面.メッセージ表示領域.サブユーザー本登録完了'
            ), //"サブユーザー本登録完了", // FE-CU54-C0012
            text: vm.$vuetify.lang.t(
              '$vuetify.FECU54Thanks画面.メッセージ詳細表示領域.サブユーザーを本登録しました'
            ), //"サブユーザーを本登録しました。", // FE-CU54-C0016
          },
          {
            id: 2,
            page: 532,
            title: vm.$vuetify.lang.t(
              '$vuetify.FECU54Thanks画面.メッセージ表示領域.メインユーザー本登録完了'
            ), //"メインユーザー本登録完了", // FE-CU54-C0013
            text: vm.$vuetify.lang.t(
              '$vuetify.FECU54Thanks画面.メッセージ詳細表示領域.メインユーザーを本登録しました'
            ), //"メインユーザーを本登録しました。", // FE-CU54-C0017
          },
          {
            id: 3,
            page: 6,
            title: vm.$vuetify.lang.t(
              '$vuetify.FECU54Thanks画面.メッセージ表示領域.パスワード初期化完了'
            ), //"パスワード初期化完了", // FE-CU54-C0014
            text: vm.$vuetify.lang.t(
              '$vuetify.FECU54Thanks画面.メッセージ詳細表示領域.パスワードを初期化しました'
            ), //"パスワードを初期化しました。", // FE-CU54-C0018
          },
          {
            title: vm.$vuetify.lang.t(
              '$vuetify.FECU54Thanks画面.メッセージ表示領域.サービス追加完了'
            ), //"サービス追加完了", // FE-CU54-C0023
            text: vm.$vuetify.lang.t(
              '$vuetify.FECU54Thanks画面.メッセージ詳細表示領域.サービスを追加しました'
            ), //"サービスを追加しました。", // FE-CU54-C0024?
          },
        ],
      };
    },
  },
  props: {
    fromPageInfo: {
      type: Object,
      default: {},
      require: false,
    },
  },
  mounted: function () {
    let page = this.pageInfo.page;
    let cont = 0;
    this.contentsInfo.forEach(function (item) {
      if (item.page == page) {
        cont = item.id;
      }
    });
    this.contents = cont;
  },
  /** @type {Methods} */
  methods: {
    /**
     * 画面遷移処理
     * @param {String} url 画面遷移先パス
     */
    replace(url) {
      if (url) {
        this.$router.replace({
          path: url,
        });
      }
    },
  },
};
